import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';

import { InitialSetupBaseComponent } from '../initial-setup-base/initial-setup-base.component';
import { CompanyProfile } from 'projects/workspace/src/app/administration/models/company-profile.model';
import { AdministrationsApiService } from 'projects/workspace/src/app/administration/services/administrations-api.service';
import { AppState } from 'projects/workspace/src/app/store/state/app.state';

@Component({
  selector: 'rnpl-app-features',
  templateUrl: './app-features.component.html',
  styleUrls: ['./app-features.component.scss'],
})
export class AppFeaturesComponent extends InitialSetupBaseComponent implements OnInit {

  public form: FormGroup = this.fb.group({});

  constructor(
    public fb: FormBuilder,
    public readonly store: Store<AppState>,
    public router: Router,
    public readonly administrationsApiService: AdministrationsApiService,
  ) {
    super(store, router, administrationsApiService);
  }

  ngOnInit() {
    this.initForm();
  }

  public initForm(): void {
    this.form = this.fb.group({
      inventoryManagement: [false],
      onlineSales: [false],
      timeTracking: [false],
    });
  }

  public updateStep$(): Observable<boolean | CompanyProfile> {
    const formValue = this.form.getRawValue();
    const company: CompanyProfile = {
      ...this.companyProfile,
      subscriptionManagement: {
        ...this.companyProfile.subscriptionManagement,
        extensionsUser: {
          ...this.companyProfile.subscriptionManagement.extensionsUser,
          ...formValue
        }
      }
    };

    return this.updateCompanySbcManagement$(company);
  }

  get inventoryManagement() { return this.form.get('inventoryManagement') as FormControl; }
  get onlineSales() { return this.form.get('onlineSales') as FormControl; }
  get timeTracking() { return this.form.get('timeTracking') as FormControl; }

}
